export const SET_FORM = 'AUDIT_MISSION/EDIT/SET_FORM'
export const SET_SELECTED_CARDS = 'AUDIT_MISSION/EDIT/SET_SELECTED_CARDS'
export const SET_SELECTED_CARD_ITEM =
  'AUDIT_MISSION/EDIT/SET_SELECTED_CARD_ITEM'
export const SET_INITIAL_STATE = 'AUDIT_MISSION/EDIT/SET_INITIAL_STATE'
